export var MAX_UNITS_LENGTH = {
  KBYTE: 1024,
  MEGABYTE: 1048576,
  SECONDS: 60
};